import React, { useState, useEffect } from 'react';
import { Stack, Text, DefaultButton, Nav } from '@fluentui/react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Settings from './components/Settings';
import AdminPanel from './components/AdminPanel';
function App() {
    const [userInfo, setUserInfo] = useState(null);
    const isAdmin = userInfo?.userRoles?.includes('admin');
    const navLinks = [
        {
            name: 'Dashboard',
            url: '/',
            key: 'dashboard',
            icon: 'ViewDashboard'
        },
        {
            name: 'Settings',
            url: '/settings',
            key: 'settings',
            icon: 'Settings'
        },
        ...(isAdmin ? [{
            name: 'Admin',
            url: '/admin',
            key: 'admin',
            icon: 'Admin'
        }] : [])
    ];

    useEffect(() => {
        /*
        console.log('Full env object:', {
            useLocalAuth: process.env.REACT_APP_USE_LOCAL_AUTH,
            nodeEnv: process.env.NODE_ENV
        });
        console.log('Fetching from:', process.env.REACT_APP_USE_LOCAL_AUTH ? '/auth/me.json' : '/.auth/me');
        */
        fetch('/.auth/me')
            .then(response => {
                //console.log('Auth response:', response);
                return response.json();
            })
            .then(data => {
                //console.log('Raw auth data:', data);
                const userData = Array.isArray(data) ? data[0]?.clientPrincipal : data.clientPrincipal;
                //console.log('Setting userInfo to:', userData);
                setUserInfo(userData);

                // Capture this user's B2C identity (display name, email,
                // identity provider) in Cosmos so the admin panel can show
                // real names instead of raw partition-key GUIDs. Best-effort:
                // a failure here must not block the app from rendering.
                if (userData?.userId) {
                    fetch('/api/me-upsert', { method: 'POST' })
                        .catch(err => console.log('me-upsert failed:', err));
                }
            })
            .catch((error) => {
                console.log('Auth error:', error);
                setUserInfo(null);
            });
    }, []);

    function AuthenticatedSettings({ userInfo }) {
        if (!userInfo) {
            return <Text>Loading authentication...</Text>;
        }
        return <Settings userInfo={userInfo} />;
    }

    return (
        <BrowserRouter>
            <Stack horizontal tokens={{ padding: 20 }}>
                {userInfo && (
                    <Stack.Item styles={{ root: { width: 200 } }}>
                        <Nav
                            styles={{ root: { height: '100vh' } }}
                            groups={[{ links: navLinks }]}
                        />
                    </Stack.Item>
                )}
                <Stack.Item grow>
                    <Stack>
                        <Stack horizontal horizontalAlign="space-between">
                            <Text variant="xxLarge">CalSync Web</Text>
                            {userInfo ? (
                                <Stack>
                                    <Text>Welcome {userInfo?.userDetails}</Text>
                                    <DefaultButton
                                        text="Sign Out"
                                        onClick={() => window.location.href = '/.auth/logout'}
                                    />
                                </Stack>
                            ) : (
                                <DefaultButton
                                    text="Sign In"
                                    onClick={() => window.location.href = '/.auth/login/aadb2c'}
                                />
                            )}
                        </Stack>
                        {userInfo && (
                            <Routes>
                                <Route path="/" element={<Dashboard />} />
                                <Route
                                    path="/settings"
                                    element={<AuthenticatedSettings userInfo={userInfo} />}
                                />
                                {isAdmin && (
                                    <Route path="/admin" element={<AdminPanel />} />
                                )}
                            </Routes>
                        )}
                    </Stack>
                </Stack.Item>
            </Stack>
        </BrowserRouter>
    );
}
export default App;